export default function initProductsTabs() {
    const tabs = document.querySelectorAll('.c-products-tabs__btn');
    const panels = document.querySelectorAll('.c-products-tabs__panel');
    const sliders = document.querySelectorAll('.c-products-tabs__slider');

    if (!tabs.length || !panels.length) return;

    // INICIALIZA TODOS OS SWIPERS DA SEÇÃO
    sliders.forEach(slider => {
        // Encontra o painel pai deste slider específico
        const parentPanel = slider.closest('.c-products-tabs__panel');
        // Busca a paginação correspondente apenas dentro desse painel
        const paginationEl = parentPanel.querySelector('.c-products-tabs__pagination');

        new Swiper(slider, {
            slidesPerView: 'auto',
            spaceBetween: 9,

            // O observer é crucial aqui, você fez certinho em manter
            observer: true,
            observeParents: true,

            pagination: {
                // Passa o elemento HTML específico que encontramos, e não uma string genérica
                el: paginationEl,
                clickable: true,
            },

            breakpoints: {
                992: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                }
            }
        });
    });

    // LÓGICA DAS ABAS (ACESSIBILIDADE)
    tabs.forEach(tab => {
        tab.addEventListener('click', switchTab);
    });

    function switchTab(e) {
        const clickedTab = e.currentTarget;
        const targetPanelId = clickedTab.getAttribute('aria-controls');
        const targetPanel = document.getElementById(targetPanelId);

        // Remove active state de todas as abas e painéis
        tabs.forEach(t => {
            t.setAttribute('aria-selected', 'false');
            t.setAttribute('tabindex', '-1');
            t.classList.remove('is-active');
        });

        panels.forEach(p => {
            p.setAttribute('hidden', 'true'); // Atributo HTML nativo
            p.classList.remove('is-active');
        });

        // Adiciona active state na clicada
        clickedTab.setAttribute('aria-selected', 'true');
        clickedTab.setAttribute('tabindex', '0');
        clickedTab.classList.add('is-active');

        targetPanel.removeAttribute('hidden');
        targetPanel.classList.add('is-active');
    }
}